module.exports = __webpack_public_path__ + "static/media/banner_undershape.75b1b7b4.png";